import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  ModalForm,
  FileUpload,
  FieldGroup,
  FloatingLabelFormField,
  SelectControl,
  FormSection,
  ChakraUIProvider,
} from '@everfi/reactifi';
import i18n from 'lib/utility/i18n';
import { importContentFile } from '../../../lib/utility/importContentFile';

const ImportConfigModal = ({ tabindex = '-1', type, authToken, url, layouts = [], content }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const importData = { mediaId: null };
  const [selectedLayout, setSelectedLayout] = useState(null);

  const closeModal = () => {
    setSelectedLayout(null);
    setModalOpen(false);
  };

  const openModal = event => {
    event.preventDefault();
    setModalOpen(true);
  };

  const handleImportFileUploadSuccess = response => {
    setTimeout(() => {
      closeModal();
      window.location.reload();
    }, 3000);
  };

  const onLayoutChange = element => {
    if (!element.slug) return;

    setSelectedLayout(element.slug);
  };

  const getTitle = () => {
    return `${i18n.t('Import')} ${i18n.t(type)}`;
  };

  return (
    <div id="fileUploaderModal">
      <a tabIndex={tabindex} href="#" className="file-uploader-link btn btn-primary" onClick={openModal}>
        <span>{getTitle()}</span>
      </a>
      <ChakraUIProvider>
        <ModalForm
          renderAsLegacy={true}
          show={modalOpen}
          onCancelClose={closeModal}
          onCancel={closeModal}
          data={importData}
          saveAndAddButton={false}
          saveButton={false}
          title={getTitle()}
          skipCancelConfirmation={true}
          className="import-modal"
        >
          <FormSection title="Layout">
            {type === 'page' && layouts.length && (
              <FloatingLabelFormField
                caption="Select Layout"
                required={true}
                dataValue={selectedLayout}
                name="selected_layout"
              >
                <SelectControl
                  multi={false}
                  placeholderText="Layout"
                  options={layouts}
                  valueKey="slug"
                  labelKey="name"
                  onChange={onLayoutChange}
                />
              </FloatingLabelFormField>
            )}
            {(selectedLayout || type === 'Layout') && (
              <FieldGroup className="container-fluid">
                <div className="row">
                  <div className="col-12">{i18n.t('Create a content record by uploading a JSON file.')}</div>
                </div>
                <FieldGroup className="row">
                  <FieldGroup className="col-12">
                    <FileUpload
                      uploader={importContentFile}
                      parameters={selectedLayout}
                      header={false}
                      name="mediaId"
                      accept={['.json', 'application/json']}
                      icon={{
                        className: 'images',
                        fileClassName: 'file',
                        noFileClassName: 'file-slash',
                      }}
                      button={{
                        text: i18n.t('Select a File'),
                        className: 'btn btn-secondary',
                      }}
                      actions={{
                        success: handleImportFileUploadSuccess,
                      }}
                      className="import-file-upload"
                      authToken={authToken}
                    />
                  </FieldGroup>
                </FieldGroup>
              </FieldGroup>
            )}
          </FormSection>
        </ModalForm>
      </ChakraUIProvider>
    </div>
  );
};

ImportConfigModal.propTypes = {
  tabindex: PropTypes.string,
  type: PropTypes.string,
  authToken: PropTypes.string,
  url: PropTypes.string,
  layouts: PropTypes.array,
  content: PropTypes.object,
};

export default ImportConfigModal;
